<template>
  <div>
    <CRow>
      <CCol  col="12 col-sm-8">
        <CCard>
          <CCardHeader>
            <div class="d-flex p-2 align-items-center justify-content-between lines-header-actions">
              <CButton
                  v-if="has_permission('reserve_times')"
                  color="primary"
                  size="sm"
                  @click="openAddLineModal"
                  class="add-line-btn"
              >{{ $t('add_new_line') }}</CButton>
              <strong class="lines-title">{{ $t('lines') }}</strong>
            </div>
          </CCardHeader>


        </CCard>

        <CCard v-for="item in items" class="line-card">
          <CCardHeader class="line-header d-flex flex-column mb-3" >
            <div class="w-100 d-flex align-items-center justify-content-between line-header-content">
              <div class="d-flex align-items-center line-actions-group">
                <CButton
                    v-if="has_permission('reserve_times')"
                    color="danger"
                    variant="outline"
                    square
                    class="delete-line-btn"
                    size="sm"
                    @click="delete_line_dialog(item)"
                >{{ $t('delete_line') }}</CButton>
                <CButton
                    v-if="has_permission('reserve_times')"
                    color="primary"
                    variant="outline"
                    square
                    class="edit-line-btn"
                    size="sm"
                    @click="editDetails(item)"
                >{{ $t('edit_line') }}</CButton>
              </div>
              <div class="d-flex align-items-center line-title-section">
                <img :src="item.logo" class="rounded-circle line-logo" width="70px" height="70px"/>
                <div class="mx-2">
                  <strong>{{ item.title }}</strong>
                </div>
              </div>
            </div>
            <div class="w-100 mt-2 add-member-button-container">
              <CButton
                  v-if="has_permission('reserve_times')"
                  color="primary"
                  square
                  class="py-2 w-100 add-member-button"
                  size="sm"
                  style="padding: 0.375rem 0.9rem !important;"

                  @click="add_user_to_line(item)"
              >{{ $t('add_user_to_line') }}</CButton>
            </div>
          </CCardHeader>
          <CCardBody>
            <div v-for="admin in item.admins" class="member-item">
              <div class="member-background-overlay" :style="{ backgroundImage: `url(${admin.admin.image})` }"></div>
              <div class="member-content">
                <div class="member-header-row">
                  <div class="member-info">
                    <div class="member-name">
                      <strong>{{ admin.admin.name }}</strong>
                    </div>
                  </div>
                  <CButton
                      v-if="has_permission('reserve_times')"
                      color="danger"
                      variant="outline"
                      square
                      class="delete-member-btn bg-white"
                      size="sm"
                      @click="delete_user_dialog(item,admin)"
                  >{{ $t('delete_user') }}</CButton>

                </div>
                <div class="member-actions mt-2">
                  <CButton
                      v-if="has_permission('reserve_times') || my_user_id == admin.admin.id"
                      color="primary"
                      variant="outline"
                      square
                      size="sm"
                      class="bg-white"
                      style="padding: 0.375rem 0.9rem !important;"
                      @click="go_to_reservation(item,admin)"
                  >{{ $t('reservation_hours') }}</CButton>

                  <CButton
                      v-if="has_permission('reserve_times') || my_user_id == admin.admin.id"
                      square
                      size="sm"
                      class="glass"
                      style="padding: 0.375rem 0.9rem !important;"

                      @click="go_to_reserve_list(item,admin)"
                  >{{ $t('reservation_list') }}</CButton>
                </div>
                <div class="member-actions mt-2">
                  <CInput
                      v-if="has_permission('reserve_times')"
                      v-model="admin.price"
                  >
                    <template #prepend-content>Price</template>
                    <template #append>
                      <CButton @click="update_service_price(admin,item)" color="info"  size="sm" ><CIcon name="cil-check"/></CButton>
                    </template>
                  </CInput>
                </div>
              </div>
            </div>

          </CCardBody>
        </CCard>

      </CCol>
      <CCol  col="12 col-sm-4" v-if="has_permission('reserve_times')" class="d-none d-md-block">
        <CCard>
          <CCardHeader>
            <strong>{{ $t('add_line') }}</strong>
          </CCardHeader>
          <CCardBody>
            <CRow>
              <CCol col="12">
                <CInput
                    v-model="name"
class="required"
                    :label="$t('line_name')"
                />
              </CCol>
              <CCol col="12">
                <ImageSelector :label="$t('image')"
                               class="required"
                               :media_id.sync="file"
                               default_archive="blog_category"
                               :preview-image="previewImage"
                />

              </CCol>

            </CRow>


          </CCardBody>
          <CCardFooter>
            <CButton v-if="status_form==0"
                @click="login()"
                type="submit" ref="submit_form" size="sm" color="primary">{{ $t('add_line') }}</CButton>

            <CButton v-if="status_form!=0"
                     @click="login()"
                     class="mr-1"
                     size="sm" color="warning">{{ $t('edit_line') }}</CButton>
            <CButton v-if="status_form!=0"
                     @click="cancel_form()"
                     class="mr-1"

                     size="sm" color="danger">
              {{ $t('cancel') }}
            </CButton>
          </CCardFooter>
        </CCard>
      </CCol>
    </CRow>
    <!-- Modal for Add/Edit Line -->
    <CModal
        :title="status_form == 0 ?  $t('add_line')  :  $t('edit_line') "
        :show.sync="showLineModal"
        color="primary"
        size="lg"
        :centered="true"
        class="line-modal"
    >
      <CCardBody>
        <CRow>
          <CCol col="12">
            <CInput
                v-model="name"
                class="required"
                :label="$t('table_name')"
            />
          </CCol>
          <CCol col="12">
            <ImageSelector :label="$t('image')"
                           class="required"
                           :media_id.sync="file"
                           default_archive="blog_category"
                           :preview-image="previewImage"
            />
          </CCol>
        </CRow>
      </CCardBody>
      <template #footer>
        <CButton v-if="status_form==0"
                 @click="login()"
                 type="submit" ref="submit_form" size="sm" color="primary">{{ $t('add_line') }}</CButton>
        <CButton v-if="status_form!=0"
                 @click="login()"
                 class="mr-1"
                 size="sm" color="warning">{{ $t('edit_line') }}</CButton>
        <CButton
            @click="closeLineModal()"
            class="mr-1"
            size="sm" color="secondary">
          {{ $t('cancel') }}
        </CButton>
      </template>
    </CModal>

    <CModal
        :title="$t('add_user_to_line')"
        color="info"
        :closeOnBackdrop="false"
        :show.sync="dialog_add_user"
    >
      <treeselect
          v-model="selected_user_to_add"
          :multiple="false"
          :async="false"
          :options="admins"
          :placeholder="$t('select_user')"
          :normalizer="normalizer_admins"
      />

      <template #footer>
        <CButton @click="dialog_add_user = false" color="danger">{{ $t('cancel') }}</CButton>
        <CButton @click="dialog_add_user=false,add_admin()" color="success">{{ $t('ok') }}</CButton>
      </template>
    </CModal>
  </div>

</template>

<script>
import axios from "axios";

import {bus} from '../../main';
import Treeselect, {ASYNC_SEARCH} from "@riophae/vue-treeselect";
const simulateAsyncOperation = fn => {
  setTimeout(fn, 200)
}

export default {
  name: 'Login',
  components: {Treeselect},
  data() {
    return {
      my_user_id:0,
      confirm_delete_user:new Date().getTime()+"_"+this.$vnode.tag+"user",
      confirm_delete_line:new Date().getTime()+"_"+this.$vnode.tag+"line",
      name: '',
      code: '',
      dialog_add_user:false,
      showLineModal: false,
      file: [],
      color: '',
      previewImage: null,
      description: '',
      selected_line: 0,
      selected_user_to_add:null,
      items: [],
      fields: [
        {key: 'row',label: '#', _style: 'width:7%'},
        {key: 'logo',label: this.$t('image'), _style: 'width:20%'},
        {key: 'title',label: this.$t('name'), _style: 'width:20%'},
        {key: 'operation',label: this.$t('operation'), _style: 'width:10%;'},

      ],
admins:[],
      status_form: 0,
      status_form_admin: 0,
      normalizer_admins(node) {
        return {
          id: node.id,
          label: node.name,
        }
      },
    }
  },
  mounted() {
    this.my_user_id = localStorage.getItem('user_id')
    this.get_categories();
    this.get_admins();
    bus.$on(this.confirm_delete_user, (data) => {
      // alert(data);
      if (data == "true") {
        this.delete_admin();

      } else {
        this.status_form = 0;
      }
    });
    bus.$on(this.confirm_delete_line, (data) => {
      // alert(data);
      if (data == "true") {
        this.delete_line();

      } else {
        this.status_form = 0;
      }
    });
  },
  watch: {
    '$route.params.cat_id': function () {
      this.get_categories();
    }
  },
  methods: {
    get_admins() {
      var self = this;
      console.log("route id " + this.$route.params.cat_id);
      var formData = new FormData();
      axios.post('/api/admin/user/get_admin', formData, {}).then(function (response) {

        var content_cats = response.data;

        self.admins = content_cats

      })
          .catch(function (error) {

            console.log(error);
          });

    },
    update_service_price(admin,line) {
      var self = this;
      var formData = new FormData();
      formData.append('admin_id',admin.id)
      formData.append('price',admin.price)
      formData.append('line_id',line.id)
      axios.post('/api/admin/site/update_line_admin_price', formData, {}).then(function (response) {

        self.$root.modal_component.show_api_response_modals(response);


      })
          .catch(function (error) {

            console.log(error);
          });

    },


    add_user_to_line(item){
      this.selected_line = item.id
this.dialog_add_user = true
    },
    cancel_form() {
      this.name = '';
      this.description = '';
      this.previewImage = null;
      this.file = [];

      this.status_form = 0;

    },
    editDetails(item) {
      this.name = item.title;
      this.code = item.code;
      this.file[0] = item.logo_id;
      this.status_form = item.id;
      this.showLineModal = true;
    },
    openAddLineModal() {
      this.cancel_form();
      this.showLineModal = true;
    },
    closeLineModal() {
      this.showLineModal = false;
      this.cancel_form();
    },
    go_to_reservation(item,admin){
      this.$router.push({path:'/dashboard/lines/reserve_times/'+item.id+'/'+admin.admin.id})
    },
    go_to_reserve_list(item,admin){
      this.$router.push({path:'/dashboard/lines/reservations/'+item.id+'/'+admin.admin.id})
    },
    get_categories() {
      var self = this;
var formData = new FormData();

      axios.post('/api/admin/site/get_lines',formData, {}).then(function (response) {

        var content_cats = response.data;

        self.items = content_cats.orders.map((item, row_id) => {
          return {...item, row_id}
        })

      })
          .catch(function (error) {

            console.log(error);
          });

    },


    login() {


      let self = this;
      const formData = new FormData()
      let url;
      if (this.status_form == 0) {
        url = "/api/admin/site/add_line";
      } else {

        url = "/api/admin/site/update_line";
        formData.append('id', this.status_form)

      }

      formData.append('image', this.file[0]);

      formData.append('name', this.name);
      formData.append('code', this.code);
      axios.post(url, formData, {}).then((res) => {

        self.$root.modal_component.show_api_response_modals(res);

        if (res.data.error == 0) {
          self.name = '';
          self.code = '';
          self.description = '';
          self.previewImage = '';
          self.previewImage_header = '';
          self.status_form = 0;
          self.showLineModal = false;
          self.get_categories();
        }

      })


          .catch(function (error) {

            console.log(error);
          });

    },
    add_admin() {


      let self = this;
      const formData = new FormData()
      let url;
      if (this.status_form == 0) {
        url = "/api/admin/site/add_line_admin";
      } else {
        formData.append('id', this.status_form)
      }

      formData.append('id', this.selected_line);

      formData.append('user_id', this.selected_user_to_add);
      axios.post(url, formData, {}).then((res) => {

        self.$root.modal_component.show_api_response_modals(res);

        if (res.data.error == 0) {

          self.get_categories();
        }

      })


          .catch(function (error) {

            console.log(error);
          });

    },
    delete_line_dialog(item) {
      this.$root.modal_component.show_confirm_modal(this.$t("warning"), this.$t("deleteMessage"), [this.$t("ok")], this.confirm_delete_line);

      this.status_form = item.id;

    },
    delete_user_dialog(item,admin) {
      this.$root.modal_component.show_confirm_modal(this.$t("warning"), this.$t("deleteMessage"), [this.$t("ok")], this.confirm_delete_user);

      this.status_form = item.id;
      this.status_form_admin = admin.id;

    },
    delete_line() {


      let self = this;
      const formData = new FormData()
      let url;
      url = "/api/admin/site/delete_line";


      formData.append('id', this.status_form);

      axios.post(url, formData, {}).then((res) => {

        self.$root.modal_component.show_api_response_modals(res);
        self.status_form = 0;

        self.get_categories();


      })
          .catch(function (error) {
            console.log(error);
          });
    },
    delete_admin() {
      let self = this;
      const formData = new FormData()
      let url;
      url = "/api/admin/site/delete_line_admin";

      formData.append('id', this.status_form);
      formData.append('user_id', this.status_form_admin);

      axios.post(url, formData, {}).then((res) => {

        self.$root.modal_component.show_api_response_modals(res);
        self.status_form = 0;

        self.get_categories();


      })
          .catch(function (error) {
            console.log(error);
          });
    },
  }
}


</script>

<style scoped>
.lines-header-actions {
  flex-direction: row-reverse;
  width: 100%;
}

.lines-title {
  order: 2;
}

.add-line-btn {
  order: 1;
}

.line-card {
  margin-bottom: 2rem;
  padding: 0.7rem;
}

.line-header {
  padding: 1rem;
}

.line-header-content {
  width: 100%;
  flex-direction: row-reverse;
  justify-content: space-between;
}

.line-actions-group {
  display: flex;
  gap: 0.5rem;
  order: 1;
}

.delete-line-btn,
.edit-line-btn {
  white-space: nowrap;
}

.line-title-section {
  order: 2;
}

.line-modal :deep(.modal-dialog) {
  display: flex;
  align-items: center;
  min-height: calc(100% - 1rem);
  margin: 0.5rem auto;
}

.line-modal :deep(.modal-content) {
  margin: auto;
}

@media (max-width: 991px) {
  .line-modal :deep(.modal-dialog) {
    min-height: calc(100% - 3.5rem);
    margin: 1.75rem auto;
  }
}

.line-title-section {
  flex: 1;
  min-width: 200px;
  order: 2;
}

.line-logo {
  flex-shrink: 0;
  object-fit: cover;
}

.member-item {
  margin-bottom: 1rem;
  border: solid 1px #d4d4d4;
  border-radius: 0.5rem;
  position: relative;
  overflow: hidden;
  min-height: 150px;
  display: flex;
  align-items: stretch;
}

.member-background-overlay {
  position: absolute;
  top: 0;
  width: 50%;
  height: 100%;
  background-size: cover;
  background-position: center;
  filter: grayscale(0.1);
  z-index: 0;
}
html:is([dir=rtl]) .member-background-overlay {
  left: 0;
}
html:not([dir=rtl]) .member-background-overlay {
  right: 0;
}
.member-background-overlay::after {
  content: '';
  position: absolute;
  top: 0;
  width: 10%;
  height: 100%;
}
html:is([dir=rtl]) .member-background-overlay::after {
  right: 0;
  background: linear-gradient(to right, transparent 0%, rgba(255, 255, 255, 0.3) 30%, rgba(255, 255, 255, 0.9) 70%, rgba(255, 255, 255,1) 100%);

}
html:not([dir=rtl]) .member-background-overlay::after {
  left: 0;
  background: linear-gradient(to left, transparent 0%, rgba(255, 255, 255, 0.3) 30%, rgba(255, 255, 255, 0.9) 70%, rgba(255, 255, 255,1) 100%);

}
.member-content {
  position: relative;
  z-index: 2;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 1rem;
}
html:is([dir=rtl]) .member-content {
  background: linear-gradient(to right, transparent 0%, transparent 40%, rgba(255, 255, 255, 0.3) 45%, rgba(255, 255, 255, 0.7) 50%, rgba(255, 255, 255, 1) 52%);

}
html:not([dir=rtl]) .member-content {
  background: linear-gradient(to left, transparent 0%, transparent 40%, rgba(255, 255, 255, 0.3) 45%, rgba(255, 255, 255, 0.7) 50%, rgba(255, 255, 255, 1) 52%);

}
.member-header-row {
  justify-content: space-between;
  display: flex !important;
  align-items: center;
  gap: 10px;
  width: 100%;
}

.member-info {
  flex: 1;
  order: 2;
  display: flex;
  align-items: center;
}

.member-name {
  flex: 1;
  color: #333;
}

.member-avatar {
  display: none;
}

.delete-member-btn {
  order: 1;
  white-space: nowrap;
  flex-shrink: 0;
}

.member-actions {
  display: flex !important;
  flex-direction: row !important;
  flex-wrap: nowrap !important;
  gap: 0.5rem !important;
  align-items: center !important;
}

@media (max-width: 768px) {
  .line-header {
    padding: 0.75rem;
  }
  
  .line-title-section {
    width: 100%;
  }
  
  .line-logo {
    width: 60px !important;
    height: 60px !important;
  }
  
  .member-item {
    min-height: 120px;
  }
  
  .member-background-overlay {
    width: 50%;
  }
  
  .member-content {
    background: linear-gradient(to right, transparent 0%, transparent 40%, rgba(255, 255, 255, 0.3) 45%, rgba(255, 255, 255, 0.7) 50%, rgba(255, 255, 255, 1) 52%);
    padding: 0.75rem;
    height: 135px;
  }
  
  .member-info {
    margin-bottom: 10px;
    order: 1;
  }
  
  .delete-member-btn {
    order: 2;
  }
  
  .member-actions {
    width: 100%;
    justify-content: flex-start;
  }
  
  .member-actions .btn {
    flex: 1;
    min-width: calc(50% - 5px);
    font-size: 0.85rem;
    padding: 0.375rem 0.5rem;
  }
}

@media (max-width: 576px) {
  .member-actions .btn {
    flex: 1 1 100%;
    margin-bottom: 5px;
  }
}
.glass {
  background: #c3c3c380;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 5px;
  color: #ffffff;
}
</style>
